import React from "react";
import { withRouter } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Modal, ModalBody, } from 'reactstrap';
import Carousel from 'react-multi-carousel';
import {Helmet} from "react-helmet";

import media_img_1 from "../../assets/media_img_1.JPG";
import media_img_2 from "../../assets/media_img_2.JPG";
import media_img_3 from "../../assets/media_img_3.JPG";
import media_img_4 from "../../assets/media_img_4.jpg";
import media_img_5 from "../../assets/media_img_5.jpg";
import media_img_6 from "../../assets/media_img_6.jpg";
import media_img_7 from "../../assets/media_img_7.JPG";
import media_img_8 from "../../assets/media_img_8.JPG";
import media_img_9 from "../../assets/media_img_9.jpg";
import media_img_10 from "../../assets/media_img_10.jpg";
import kiphire_1 from "../../assets/kiphire_1.jpg";
import kiphire_2 from "../../assets/kiphire_2.jpg";
import kiphire_3 from "../../assets/kiphire_3.jpg";
import kiphire_4 from "../../assets/kiphire_4.jpg";
import kiphire_5 from "../../assets/kiphire_5.jpg";
import kiphire_6 from "../../assets/kiphire_6.jpg";
import kiphire_8 from "../../assets/kiphire_8.jpg";
import peren_1 from "../../assets/peren_1.jpg";
import peren_2 from "../../assets/peren_2.jpg";
import peren_3 from "../../assets/peren_3.jpg";
import facility_center_1 from "../../assets/facility_center_1.jpeg";
import facility_center_2 from "../../assets/facility_center_2.jpeg";
import facility_center_3 from "../../assets/facility_center_3.jpeg";
import facility_center_4 from "../../assets/facility_center_4.jpeg";
import facility_center_5 from "../../assets/Slider9.jpeg";

import Weaving_Batch_1 from "../../assets/Weaving_Batch_1.jpeg";
import Weaving_Batch_4 from "../../assets/Weaving_Batch_4.jpeg";
import IT_based_Capacity_Building from "../../assets/IT_based_Capacity_Building.JPG";
import IT_based_Capacity_Building_4 from "../../assets/IT_based_Capacity_Building_4.JPG";
import Handicraft_2 from "../../assets/Handicraft_2.JPG";
import Handicraft_3 from "../../assets/Handicraft_3.jpg";
import Entrepreneurship_1 from "../../assets/Entrepreneurship_1.JPG";
import Entrepreneurship_2 from "../../assets/Entrepreneurship_2.JPG";
import Entrepreneurship_3 from "../../assets/Entrepreneurship_3.JPG";
import "./media.css";
import Footer from "../../components/Footer/footer";
import 'react-multi-carousel/lib/styles.css';

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      paritialVisibilityGutter: 0
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      paritialVisibilityGutter: 0
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 0
    }
  };

class media extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        activeLayout: "",
        imageModal: false
    };
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }
  render() {
    return (
      <div>
        <Helmet>
            <html lang="en" />  
            <meta charSet="utf-8" />
            <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft | Media</title>
            <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
            <link rel="canonical" href="https://nielitdihh.in/" />
        </Helmet>
        <Modal
          isOpen={this.state.imageModal} centered={true} toggle={() => this.setState({imageModal: false})} size="xl" className="border-radius-10"
        >
            <ModalBody>
                <div>
                    {
                        this.state.activeLayout == "Launch Event" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={media_img_1} alt="NIELIT Kohima Digital Literacy Book Launch" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_2} alt="NIELIT Kohima Digital Literacy Book Launch" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_3} alt="NIELIT Kohima Digital Literacy Book Launch" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_4} alt="NIELIT Kohima Digital Literacy Book Launch" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                        this.state.activeLayout == "Kiphire Event 2022" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={kiphire_1} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                                <img src={kiphire_4} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                                <img src={kiphire_5} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                                <img src={kiphire_6} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                                <img src={kiphire_3} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                                <img src={kiphire_8} alt="NIELIT Kohima Digital Literacy Workshop in Kiphire" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    } 
                    {
                        this.state.activeLayout == "Mon Event 2022" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={media_img_5} alt="NIELIT Kohima Digital Literacy Workshop in Mon" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_6} alt="NIELIT Kohima Digital Literacy Workshop in Mon" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_7} alt="NIELIT Kohima Digital Literacy Workshop in Mon" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_8} alt="NIELIT Kohima Digital Literacy Workshop in Mon" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_10} alt="NIELIT Kohima Digital Literacy Workshop in Mon" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "Peren Event 2022" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={peren_1} alt="NIELIT Kohima Digital Literacy Workshop in Peren" loading="lazy" className="media_carousel_images"/>
                                <img src={peren_2} alt="NIELIT Kohima Digital Literacy Workshop in Peren" loading="lazy" className="media_carousel_images"/>
                                <img src={peren_3} alt="NIELIT Kohima Digital Literacy Workshop in Peren" loading="lazy" className="media_carousel_images"/>
                                <img src={media_img_9} alt="NIELIT Kohima Digital Literacy Workshop in Peren" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "Common Facility Center" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={facility_center_5} alt="NIELIT Kohima Common Facility Center" loading="lazy" className="media_carousel_images"/>
                                <img src={facility_center_2} alt="NIELIT Kohima Common Facility Center" loading="lazy" className="media_carousel_images"/>
                                <img src={facility_center_3} alt="NIELIT Kohima Common Facility Center" loading="lazy" className="media_carousel_images"/>
                                <img src={facility_center_4} alt="NIELIT Kohima Common Facility Center" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "Weaving Batches" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={Weaving_Batch_1} alt="NIELIT Kohima Weaving Batches" loading="lazy" className="media_carousel_images"/>
                                <img src={Weaving_Batch_4} alt="NIELIT Kohima Weaving Batches" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "IT based Capacity Building" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={IT_based_Capacity_Building} alt="NIELIT Kohima IT based Capacity Building" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "IT based Capacity Building Batch 4" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={IT_based_Capacity_Building_4} alt="NIELIT Kohima IT based Capacity Building" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "Handicraft Batch" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={Handicraft_2} alt="NIELIT Kohima Handicraft" loading="lazy" className="media_carousel_images"/>
                                <img src={Handicraft_3} alt="NIELIT Kohima Handicraft" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                    {
                       this.state.activeLayout == "Entrepreneurship & Soft Skill Development" ?
                        <>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                infinite={true}
                                arrows={true}
                                swipeable={false}
                                draggable={false}
                                responsive={responsive}
                            >
                                <img src={Entrepreneurship_3} alt="NIELIT Kohima Entrepreneurship & Soft Skill Development" loading="lazy" className="media_carousel_images"/>
                                <img src={Entrepreneurship_2} alt="NIELIT Kohima Entrepreneurship & Soft Skill Development" loading="lazy" className="media_carousel_images"/>
                                <img src={Entrepreneurship_1} alt="NIELIT Kohima Entrepreneurship & Soft Skill Development" loading="lazy" className="media_carousel_images"/>
                            </Carousel> 
                        </>
                    :
                        <></>
                    }
                </div>
            </ModalBody>
        </Modal>
        <div className="media_div_1">
          <div className="dashbaord_div_1_inner">
            <p className="dashbaord_div_1_inner_txt">Digital Intervention in Handicraft and Handloom</p>
            <p className="home_box_1_para_white">The project "Digital Intervention of Handicraft & Handloom" was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India.</p>
            <button className="requestQuote">
              <a className="href_reports" href="#media">View Gallery</a>
            </button>
          </div>
        </div>
        <div className="mediaView" id="media">
            <p className="about_para_header_default">Images Gallery</p>
            <div className="l2r_images">
                <Row className="rowsMargin">
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Weaving Batches", imageModal: true })}>
                            <img src={Weaving_Batch_4} alt="Notebook"/>
                            <div className="content_small">
                                <p>Weaving Training in NIELIT Dimapur | Batch 1 to 5</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "IT based Capacity Building", imageModal: true })}>
                            <img src={IT_based_Capacity_Building} alt="Notebook"/>
                            <div className="content_small">
                                <p>IT based Capacity building for different crafts - 27th Feb, 2024</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "IT based Capacity Building Batch 4", imageModal: true })}>
                            <img src={IT_based_Capacity_Building_4} alt="Notebook"/>
                            <div className="content_small">
                                <p>IT based Capacity building (Batch 7) - 4th Mar, 2024</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Entrepreneurship & Soft Skill Development", imageModal: true })}>
                            <img src={Entrepreneurship_3} alt="Notebook"/>
                            <div className="content_small">
                                <p>Entrepreneurship & Soft Skill Development Workshop</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12} sm={12}>
                        <div className="l2r_container" onClick={() => this.setState({activeLayout: "Handicraft Batch", imageModal: true })}>
                            <img src={Handicraft_2} alt="Notebook"/>
                            <div className="l2r_content">
                                <h3>Handicraft Batch</h3>
                                <p>Snipnets from a week long training on Wood Design Handicraft, conducted in Dimapur</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="rowsMargin">
                    <Col md={6} xs={12} sm={12}>
                        <div className="l2r_container" onClick={() => this.setState({activeLayout: "Launch Event", imageModal: true })}>
                            <img src={media_img_1} alt="Notebook"/>
                            <div className="l2r_content">
                                <h3>Launching of Digital Literacy Book</h3>
                                <p>Unveiling of Digital literacy book by Shri. Imnatiba, Hon'ble Advisor, Industries & Commerce, Govt. of Nagaland, on 24th Sept 2021</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}  xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Launch Event", imageModal: true })}>
                            <img src={media_img_2} alt="Notebook"/>
                            <div className="content_small">
                                <p>Shri Imnatiba, Advisor</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Launch Event", imageModal: true })}>
                            <img src={media_img_3} alt="Notebook"/>
                            <div className="content_small">
                                <p>Shri Lanuwabang, Director I/C - NIELIT Kohima</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Common Facility Center", imageModal: true })}>
                            <img src={facility_center_1} alt="Notebook"/>
                            <div className="content_small">
                                <p>Common Faculty Center at NIELIT Dimapur</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Common Facility Center", imageModal: true })}>
                            <img src={facility_center_3} alt="Notebook"/>
                            <div className="content_small">
                                <p>Artisan at Common Faculty Center</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="rowsMargin">
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Mon Event 2022", imageModal: true })}>
                            <img src={media_img_5} alt="Notebook"/>
                            <div className="content_small">
                                <p>Awareness Workshop for Artisans, Mon - Batch 1</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Mon Event 2022", imageModal: true })}>
                            <img src={media_img_7} alt="Notebook"/>
                            <div className="content_small">
                                <p>Resource person for Awareness Workshop in Mon</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Mon Event 2022", imageModal: true })}>
                            <img src={media_img_8} alt="Notebook"/>
                            <div className="content_small">
                                <p>Artisans at Awareness Workshop in Mon</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Peren Event 2022", imageModal: true })}>
                            <img src={media_img_9} alt="Notebook"/>
                            <div className="content_small">
                                <p>Artisans at Digital Literacy Training, Peren</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12} sm={12}>
                        <div className="l2r_container" onClick={() => this.setState({activeLayout: "Mon Event 2022", imageModal: true })}>
                            <img src={media_img_10} alt="Notebook"/>
                            <div className="l2r_content">
                                <h3>Awareness cum Digital Literacy Training in Mon</h3>
                                <p>A week long training on Digital Literacy was conducted in Mon on 16th Nov. 2021</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="rowsMargin">
                    <Col md={6} xs={12} sm={12}>
                        <div className="l2r_container" onClick={() => this.setState({activeLayout: "Peren Event 2022", imageModal: true })}>
                            <img src={peren_2} alt="Notebook"/>
                            <div className="l2r_content">
                                <h3>Awareness cum Digital Literacy Training in Peren</h3>
                                <p>One week long training on Digital Literacy was conducted for the artisians in Kiphire town, on 29th Aug. 2022</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Peren Event 2022", imageModal: true })}>
                            <img src={peren_1} alt="Notebook"/>
                            <div className="content_small">
                                <p>Shri Kheajong, NIELIT Kohima Faculty - addressing artisians in Peren.</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Kiphire Event 2022", imageModal: true })}>
                            <img src={kiphire_1} alt="Notebook"/>
                            <div className="content_small">
                                <p>Shri Daniel Meren, Scientist D - addressing the artisians in Kiphire</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} xs={12} sm={12}>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Kiphire Event 2022", imageModal: true })}>
                            <img src={kiphire_2} alt="Notebook"/>
                            <div className="content_small">
                                <p>Artisian in Digital Literacy Training, Kiphire</p>
                            </div>
                        </div>
                        <div className="container_small" onClick={() => this.setState({activeLayout: "Kiphire Event 2022", imageModal: true })}>
                            <img src={kiphire_3} alt="Notebook"/>
                            <div className="content_small">
                                <p>T Wati Aier, Deputy Commissioner of Kiphire</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <br></br>
            <p className="about_para_header_default">Videos Gallery</p>
            <Row>
                <Col md={6}>
                    <div className="videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/1euOHnek_sE"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="largeVideoFrame"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>
                <Col md={3} xs={12} sm={12}>
                    <div className="container_small videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/WFHT-gNGU1M"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/JmAUrP2siJ0"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>     
                <Col md={3} xs={12} sm={12}>
                    <div className="container_small videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/Wszg5Yt3Adk"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/4n3oI6f05Pc"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>                
            </Row>
            <Row className="rowsMargin">
                <Col md={3} xs={12} sm={12}>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/MEp3qfgG5h0"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/6euAUWYF4L0"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>
                <Col md={3} xs={12} sm={12}>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/MnRehxPqjYc"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/9H1AF3wgDNo"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/_GBB13WjStU"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="largeVideoFrame"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <div className="videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/LGKeLqgvSIU"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="largeVideoFrame"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>
                  
                <Col md={3} xs={12} sm={12}>
                    <div className="container_small videosMobileMargin">
                        <iframe
                            src="https://www.youtube.com/embed/8MAzkEsbPOg"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                    <div className="container_small">
                        <iframe
                            src="https://www.youtube.com/embed/0Y7uiDhnVPM"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            height="100%"
                            width="100%"
                            style={{borderRadius: 10}}
                        ></iframe>
                    </div>
                </Col>                
            </Row>
        </div>
        <Footer/>
    </div>
    )
  }
}
export default withRouter(media);